import { ENGLISH_LANG_CODE } from "@evennt-tech/api-v2-core";
import { useTolgee } from "@tolgee/react";

export const useLocalisedLanguageCode = (localised = false): string => {
  const activeLanguage =
    useTolgee(["language"]).getLanguage() ?? ENGLISH_LANG_CODE;

  return localised ? activeLanguage : ENGLISH_LANG_CODE;
};

export const toQueryLanguageCode = (
  languageCode?: string
): string | undefined =>
  !languageCode || languageCode === ENGLISH_LANG_CODE
    ? undefined
    : languageCode;

export default useLocalisedLanguageCode;
